module.exports = __webpack_public_path__ + "static/media/TrashJoes-man.2900a70f.png";